



import React, { useState, useRef, useEffect } from "react";
import Main from "./Main";
import AddBank from "../components/AddBank";
import MainWallet from "../components/MainWallet";
import AepsToMain from "../components/AepsToMain";
import DashboardBoxes from "../components/DashboardBoxes";
import WalletLedger from "../components/WalletLedger";
import AddMoneyLedger from "../components/AddMoneyLedger";

import { useWallet } from "../context/walletContext";
import { autoDateFormat } from "../utils/autoDateFormate";

import { Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";

import {
  Edit as EditSquareIcon,
  AccountBalanceRounded as AccountBalanceRoundedIcon,
  SyncAltRounded as SyncAltRoundedIcon,
  MailOutlineRounded as MailOutlineRoundedIcon,
  MoreVertRounded as MoreVertRoundedIcon,
  PaymentsOutlined as PaymentsOutlinedIcon,
  MedicalInformationOutlined as MedicalInformationOutlinedIcon,
} from "@mui/icons-material";

import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
import ConfirmDialog from "../components/ui/ConfirmDialog";

import { maskedElement } from "../utils/maskedElement";
import { useDispatch, useSelector } from "react-redux";
import {
  updateMarchantIamges,
  getMyKycDetails,
  editMyKycDetails,
  updateMyProfile,
} from "../api/userAuth";
import { showToastMessage } from "../utils/toastUtils";
import { toMediaUrl } from "../utils/mediaUrl";
import { updateUserInfo } from "../features/authSlice";

const ProfileDashboard = () => {
  const [open, setOpen] = useState(false);
  const [aepsOpen, setAepsOpen] = useState(false);
  const [mainWalletOpen, setMainWalletOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [showBoxes, setShowBoxes] = useState(true);
  const [confirmKycUpdate, setConfirmKycUpdate] = useState(false);

  const buttonRef = useRef(null);
  const contentRef = useRef(null);

  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state?.auth);
  const [kycData, setKycData] = useState(null);
const [kycLoading, setKycLoading] = useState(false);
const [kycUpdating, setKycUpdating] = useState(false);
  const { walletAmt, refreshWalletCart } = useWallet();

  // Basic account info (Name / Phone / Email) — NOT part of KYC
  const [openEdit, setOpenEdit] = useState(false);

  const [editData, setEditData] = useState({
    name: userInfo?.name || "",
    phone: userInfo?.phone || "",
    email: userInfo?.email || "",
  });

  const [profileInfoUpdating, setProfileInfoUpdating] = useState(false);
  const [confirmProfileUpdate, setConfirmProfileUpdate] = useState(false);

  // KYC identity/address details — PAN & Aadhaar are read-only here,
  // they are intentionally excluded from this editable form.
  const [openPersonalEdit, setOpenPersonalEdit] = useState(false);

 const [personalEditData, setPersonalEditData] = useState({
  fullName: "",
  fatherName: "",
  motherName: "",
  dob: "",
  gender: "",
  address: "",
  city: "",
  district: "",
  state: "",
  pin: "",
});

  const [openBranchEdit, setOpenBranchEdit] = useState(false);

  const [branchData, setBranchData] = useState({
    branchName: "Main Branch",
  });

  // =========================================================
  // PROFILE PHOTO
  // =========================================================

  const fileInputRef = useRef(null);
  const previewObjectUrlRef = useRef(null);

  const DEFAULT_PROFILE_IMAGE = "/fintech-icon.png";

  const [preview, setPreview] = useState(
    userInfo?.logo
      ? toMediaUrl(userInfo.logo)
      : DEFAULT_PROFILE_IMAGE
  );

  const [selectedFile, setSelectedFile] = useState(null);
  const [profileUpdating, setProfileUpdating] = useState(false);
  const [confirmPhotoUpdate, setConfirmPhotoUpdate] = useState(false);

  // Update preview whenever Redux userInfo.logo changes
  useEffect(() => {
    if (previewObjectUrlRef.current) {
      URL.revokeObjectURL(previewObjectUrlRef.current);
      previewObjectUrlRef.current = null;
    }

    setPreview(
      userInfo?.logo
        ? toMediaUrl(userInfo.logo)
        : DEFAULT_PROFILE_IMAGE
    );
  }, [userInfo?.logo]);

  // Keep the basic-info edit form in sync with Redux whenever it isn't
  // open (so we never clobber what the user is actively typing, but the
  // modal always opens with fresh data — no stale name/phone/email).
  useEffect(() => {
    if (openEdit) return;


    setEditData({
      name: userInfo?.name || "",
      phone: userInfo?.phone || "",
      email: userInfo?.email || "",
    });
  }, [userInfo?.name, userInfo?.phone, userInfo?.email, openEdit]);

  // Cleanup object URL on unmount
  useEffect(() => {
    return () => {
      if (previewObjectUrlRef.current) {
        URL.revokeObjectURL(previewObjectUrlRef.current);
      }
    };
  }, []);

  useEffect(() => {
  const fetchMyKyc = async () => {
    try {
      setKycLoading(true);

      const result = await getMyKycDetails();

      if (result?.success) {
        setKycData(result?.data || null);

        const kyc = result?.data || {};

        console.log("get the data",kyc)

      setPersonalEditData({
  fullName: kyc?.fullName || "",
  fatherName: kyc?.fatherName || "",
  motherName: kyc?.motherName || "",
  dob: kyc?.dob
    ? new Date(kyc.dob).toISOString().split("T")[0]
    : "",
  gender: kyc?.gender || "",
  address: kyc?.address || "",
  city: kyc?.city || "",
  district: kyc?.district || "",
  state: kyc?.state || "",
  pin: kyc?.pin || "",
});
      } else {
        setKycData(null);

        if (result?.status !== 404) {
          showToastMessage(
            "error",
            result?.message || "Failed to fetch KYC details"
          );
        }
      }
    } catch (error) {
      console.error("Fetch KYC error:", error);

      showToastMessage(
        "error",
        "Failed to load KYC details"
      );
    } finally {
      setKycLoading(false);
    }
  };

  if (userInfo?._id) {
    fetchMyKyc();
  }
}, [userInfo?._id]);

  const handleButtonClick = () => {
    if (profileUpdating) return;

    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    // Validate image type
    if (!file.type.startsWith("image/")) {
      showToastMessage("error", "Please select a valid image");

      e.target.value = "";
      return;
    }

    // Validate image size
    if (file.size > 5 * 1024 * 1024) {
      showToastMessage(
        "error",
        "Image size must be less than 5MB"
      );

      e.target.value = "";
      return;
    }

    // Remove previous object URL
    if (previewObjectUrlRef.current) {
      URL.revokeObjectURL(previewObjectUrlRef.current);
    }

    // Create local preview
    const imageUrl = URL.createObjectURL(file);

    previewObjectUrlRef.current = imageUrl;

    setSelectedFile(file);
    setPreview(imageUrl);

    // Allow selecting same file again
    e.target.value = "";
  };

  // Open confirmation dialog
  const handleUpdateProfile = () => {
    if (!selectedFile) {
      showToastMessage(
        "error",
        "Please select a profile photo first"
      );

      return;
    }

    setConfirmPhotoUpdate(true);
  };

  // Actual API update
  const runPhotoUpdate = async () => {
    if (!selectedFile) {
      setConfirmPhotoUpdate(false);

      return showToastMessage(
        "error",
        "Please select a profile photo"
      );
    }

    if (!userInfo?._id) {
      setConfirmPhotoUpdate(false);

      return showToastMessage(
        "error",
        "User not found"
      );
    }

    const payload = new FormData();

    payload.append("logo", selectedFile);

    try {
      setProfileUpdating(true);

      const data = await updateMarchantIamges(
        userInfo._id,
        payload
      );

      if (data?.success) {
        const updatedUser = data?.data;

        const updatedLogo = updatedUser?.logo || null;
        const updatedLogoPublicId =
          updatedUser?.logoPublicId || null;

        // Update Redux user info
        dispatch(
          updateUserInfo({
            logo: updatedLogo,
            logoPublicId: updatedLogoPublicId,
          })
        );

        // Clear selected file
        setSelectedFile(null);

        // Revoke local preview
        if (previewObjectUrlRef.current) {
          URL.revokeObjectURL(previewObjectUrlRef.current);
          previewObjectUrlRef.current = null;
        }

        // Update image immediately
        setPreview(
          updatedLogo
            ? toMediaUrl(updatedLogo)
            : DEFAULT_PROFILE_IMAGE
        );

        showToastMessage(
          "success",
          data?.message ||
            "Profile photo updated successfully"
        );
      } else {
        showToastMessage(
          "error",
          data?.message ||
            "Profile photo update failed"
        );
      }
    } catch (error) {
      console.error(
        "Profile photo update error:",
        error
      );

      showToastMessage(
        "error",
        "Server error while updating profile photo"
      );
    } finally {
      setProfileUpdating(false);
      setConfirmPhotoUpdate(false);
    }
  };

  // =========================================================
  // COMMON ACTIONS
  // =========================================================

  const openDropdown = (setter) => {
    setMenuAnchor(null);

    setTimeout(() => {
      setter(true);
    }, 50);
  };

  const onClose = () => {
    setMainWalletOpen(false);
    setAepsOpen(false);
    setOpen(false);

    refreshWalletCart();
  };


const handleUpdateKyc = () => {
  const {
    fullName,
    fatherName,
    motherName,
    dob,
    gender,
    address,
    city,
    district,
    state,
    pin,
  } = personalEditData;

  if (!fullName?.trim()) {
    return showToastMessage("error", "Full name is required");
  }

  if (!fatherName?.trim()) {
    return showToastMessage("error", "Father name is required");
  }

  if (!motherName?.trim()) {
    return showToastMessage("error", "Mother name is required");
  }

  if (!dob) {
    return showToastMessage("error", "Date of birth is required");
  }

  if (!gender) {
    return showToastMessage("error", "Gender is required");
  }

  if (!address?.trim()) {
    return showToastMessage("error", "Address is required");
  }

  if (!city?.trim()) {
    return showToastMessage("error", "City is required");
  }

  if (!district?.trim()) {
    return showToastMessage("error", "District is required");
  }

  if (!state?.trim()) {
    return showToastMessage("error", "State is required");
  }

  if (!/^[1-9][0-9]{5}$/.test(pin)) {
    return showToastMessage("error", "Valid pincode is required");
  }

  // Validation successful
  setConfirmKycUpdate(true);
};

const runKycUpdate = async () => {
  if (!kycData?._id) {
    setConfirmKycUpdate(false);

    return showToastMessage(
      "error",
      "KYC details not found"
    );
  }

  const {
    fullName,
    fatherName,
    motherName,
    dob,
    gender,
    address,
    city,
    district,
    state,
    pin,
  } = personalEditData;

  try {
    setKycUpdating(true);

    const formData = new FormData();

    // NOTE: PAN and Aadhaar are intentionally never sent here — they are
    // immutable once captured and this form has no inputs for them.
    formData.append("fullName", fullName.trim());
    formData.append("fatherName", fatherName.trim());
    formData.append("motherName", motherName.trim());
    formData.append("dob", dob);
    formData.append("gender", gender);
    formData.append("address", address.trim());
    formData.append("city", city.trim());
    formData.append("district", district.trim());
    formData.append("state", state.trim());
    formData.append("pin", pin.trim());

    const result = await editMyKycDetails(formData);

    if (!result?.success) {
      return showToastMessage(
        "error",
        result?.message || "KYC update failed"
      );
    }

    const updatedKyc =
      result?.data?.kyc || result?.data;

    // Update local KYC state
    setKycData(updatedKyc);

    // Update edit form state also
    setPersonalEditData((prev) => ({
      ...prev,
      fullName: updatedKyc?.fullName || prev.fullName,
      fatherName:
        updatedKyc?.fatherName || prev.fatherName,
      motherName:
        updatedKyc?.motherName || prev.motherName,
      dob: updatedKyc?.dob
        ? new Date(updatedKyc.dob)
            .toISOString()
            .split("T")[0]
        : prev.dob,
      gender: updatedKyc?.gender || prev.gender,
      address: updatedKyc?.address || prev.address,
      city: updatedKyc?.city || prev.city,
      district:
        updatedKyc?.district || prev.district,
      state: updatedKyc?.state || prev.state,
      pin: updatedKyc?.pin || prev.pin,
    }));

    // Sync Redux so the header/name and any embedded `kyc` snapshot on
    // userInfo reflect the change immediately, without a page refresh.
    const updatedUser = result?.data?.user;

    dispatch(
      updateUserInfo({
        name: updatedUser?.name || updatedKyc?.fullName || userInfo?.name,
        ...(userInfo?.kyc
          ? { kyc: { ...userInfo.kyc, ...updatedKyc } }
          : {}),
      })
    );

    setOpenPersonalEdit(false);

    showToastMessage(
      "success",
      result?.message || "KYC updated successfully"
    );
  } catch (error) {
    console.error("Update KYC error:", error);

    showToastMessage(
      "error",
      "Failed to update KYC"
    );
  } finally {
    setKycUpdating(false);
    setConfirmKycUpdate(false);
  }
};

  // =========================================================
  // BASIC PROFILE INFO (Name / Phone / Email)
  // =========================================================

  const handleUpdateProfileInfo = () => {
    const { name, phone, email } = editData;

    if (!name?.trim() || name.trim().length < 3) {
      return showToastMessage(
        "error",
        "Name must be at least 3 characters long"
      );
    }

    if (!/^[6-9]\d{9}$/.test(phone?.trim() || "")) {
      return showToastMessage(
        "error",
        "Enter a valid 10 digit phone number"
      );
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email?.trim() || "")) {
      return showToastMessage("error", "Enter a valid email address");
    }

    // Validation successful
    setConfirmProfileUpdate(true);
  };

  const runProfileInfoUpdate = async () => {
    if (!userInfo?._id) {
      setConfirmProfileUpdate(false);
      return showToastMessage("error", "User not found");
    }

    const payload = {
      name: editData.name.trim(),
      phone: editData.phone.trim(),
      email: editData.email.trim().toLowerCase(),
    };

    try {
      setProfileInfoUpdating(true);

      const result = await updateMyProfile(payload);

      if (!result?.success) {
        return showToastMessage(
          "error",
          result?.message || "Failed to update profile"
        );
      }

      const updatedUser = result?.data?.user || result?.data;

      // Sync Redux immediately — no page refresh needed
      dispatch(
        updateUserInfo({
          name: updatedUser?.name ?? payload.name,
          phone: updatedUser?.phone ?? payload.phone,
          email: updatedUser?.email ?? payload.email,
        })
      );

      setEditData({
        name: updatedUser?.name ?? payload.name,
        phone: updatedUser?.phone ?? payload.phone,
        email: updatedUser?.email ?? payload.email,
      });

      setOpenEdit(false);

      showToastMessage(
        "success",
        result?.message || "Profile updated successfully"
      );
    } catch (error) {
      console.error("Update profile error:", error);

      showToastMessage(
        "error",
        error?.response?.data?.message ||
          "Server error while updating profile"
      );
    } finally {
      setProfileInfoUpdating(false);
      setConfirmProfileUpdate(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        contentRef.current &&
        !contentRef.current.contains(event.target)
      ) {
        // Intentionally kept empty.
      }
    }

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);



  console.log("get the email",editData)


  return (
    <>
      <Main showRightPanel={false}>
        <AddBank
          open={open}
          close={onClose}
        />

        {aepsOpen && (
          <AepsToMain
            aeps={aepsOpen}
            close={onClose}
          />
        )}

        <MainWallet
          open={mainWalletOpen}
          close={onClose}
        />

        {/* =====================================================
            BREADCRUMBS
        ====================================================== */}

        <div className="mt-4 font-[Poppins]">
          <AppBreadcrumbs
            items={[
              {
                label: "Dashboard",
                to: "/",
              },
              {
                label: "Agent Profile",
              },
            ]}
          />

          {/* ===================================================
              PROFILE HEADER
          ==================================================== */}

          <div className="ds-card mb-3 p-3">
            <div className="flex flex-row lg:flex-row lg:items-center gap-3 min-w-0">
              <div className="flex items-center gap-2.5 flex-shrink-0">
                <img
                  src={preview}
                  alt={
                    userInfo?.name || "Profile"
                  }
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      DEFAULT_PROFILE_IMAGE;
                  }}
                  className="h-10 w-10 object-cover rounded-[var(--radius-md)] border border-[var(--border-color)]"
                />

                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 whitespace-nowrap min-w-0">
                  <p className="text-[14px] font-semibold leading-tight text-[var(--text-dark)] truncate">
                    {userInfo?.name || "Guest"}
                  </p>

                  <p className="hidden sm:block text-[var(--text-muted)] font-semibold">
                    |
                  </p>

                  <p className="text-[13px] font-semibold text-[var(--text-muted)]">
                    ID: {userInfo?.userName || "N/A"}
                  </p>
                </div>
              </div>

              {/* Desktop / tablet action strip */}
              <div className="hidden md:flex flex-1 min-w-0 items-center gap-2 overflow-x-auto ds-scroll pb-1">
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="ds-action-btn"
                >
                  <AccountBalanceRoundedIcon fontSize="small" />
                  Add Bank Account
                </button>

                <button
                  type="button"
                  onClick={() => setAepsOpen(true)}
                  className="ds-action-btn"
                >
                  <SyncAltRoundedIcon fontSize="small" />
                  Aeps to wallet
                </button>

                <button
                  type="button"
                  onClick={() =>
                    setMainWalletOpen(true)
                  }
                  className="ds-action-btn"
                >
                  <SyncAltRoundedIcon fontSize="small" />
                  Add Money To Main Wallet
                </button>

                <Link
                  to="/money-settlement"
                  className="ds-action-btn"
                >
                  <SyncAltRoundedIcon fontSize="small" />
                  Add Money Settlement
                </Link>

                <Link
                  to="/welcome-letter"
                  className="ds-action-btn"
                >
                  <MailOutlineRoundedIcon fontSize="small" />
                  Welcome Letter
                </Link>

                <Link
                  to="/id-card"
                  className="ds-action-btn"
                >
                  <MedicalInformationOutlinedIcon fontSize="small" />
                  Print ID Card
                </Link>

                <Link
                  to="/certificate"
                  className="ds-action-btn"
                >
                  <PaymentsOutlinedIcon fontSize="small" />
                  Certificate
                </Link>
              </div>

              {/* Mobile Menu */}
              <div className="md:hidden ml-auto">
                <MoreVertRoundedIcon
                  className="text-[var(--text-dark)] cursor-pointer"
                  onClick={(e) =>
                    setMenuAnchor(e.currentTarget)
                  }
                />

                <Menu
                  anchorEl={menuAnchor}
                  open={Boolean(menuAnchor)}
                  onClose={() =>
                    setMenuAnchor(null)
                  }
                >
                  <MenuItem
                    onClick={() =>
                      openDropdown(setOpen)
                    }
                  >
                    <AccountBalanceRoundedIcon fontSize="small" />
                    Add Bank Account
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      openDropdown(setAepsOpen)
                    }
                  >
                    <SyncAltRoundedIcon fontSize="small" />
                    Aeps to wallet
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      openDropdown(setMainWalletOpen)
                    }
                  >
                    <SyncAltRoundedIcon fontSize="small" />
                    Add Money To Main Wallet
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      setMenuAnchor(null)
                    }
                  >
                    <Link to="/money-settlement">
                      <SyncAltRoundedIcon fontSize="small" />
                      Add Money Settlement
                    </Link>
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      setMenuAnchor(null)
                    }
                  >
                    <Link to="/welcome-letter">
                      <MailOutlineRoundedIcon fontSize="small" />
                      Welcome Letter
                    </Link>
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      setMenuAnchor(null)
                    }
                  >
                    <Link to="/id-card">
                      <MedicalInformationOutlinedIcon fontSize="small" />
                      Print ID Card
                    </Link>
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      setMenuAnchor(null)
                    }
                  >
                    <Link to="/certificate">
                      <PaymentsOutlinedIcon fontSize="small" />
                      Certificate
                    </Link>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </div>

        {/* =====================================================
            PROFILE CONTENT
        ====================================================== */}

        <div className="flex flex-col lg:flex-row gap-4">

          {/* ===================================================
              LEFT PANEL
          ==================================================== */}

          <div className="ds-card p-6 flex flex-col gap-6 w-full lg:w-1/4">

            {/* Profile Photo */}
            <div className="flex items-center justify-between gap-4">
              <img
                src={preview}
                alt={
                  userInfo?.name || "Agent"
                }
                onClick={handleButtonClick}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src =
                    DEFAULT_PROFILE_IMAGE;
                }}
                className="w-20 h-20 rounded-full object-cover cursor-pointer border border-[var(--border-color)]"
              />

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
              />

              <button
                type="button"
                onClick={handleUpdateProfile}
                disabled={
                  !selectedFile ||
                  profileUpdating
                }
                className="ds-btn ds-btn-ghost text-xs disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {profileUpdating
                  ? "Updating..."
                  : "Update Photo"}
              </button>
            </div>

            {/* =================================================
                AGENT INFO
            ================================================== */}

            <div className="relative border border-[var(--border-color)] rounded-[var(--radius-md)] p-4 text-sm bg-[var(--surface-color)] font-outfit">
              <button
                type="button"
                className="absolute top-3 right-3 make-text-primary hover:opacity-80 transition"
                onClick={() => {
                  setEditData({
                    name:
                      userInfo?.name || "",
                    phone:
                      userInfo?.phone || "",
                      email:
                      userInfo?.email || "",
                  });

                  setOpenEdit(true);
                }}
              >
                <EditSquareIcon fontSize="small" />
              </button>

              <div className="space-y-3">
                <div>
                  <h4 className="font-semibold text-[var(--text-muted)]">
                    Rank
                  </h4>
                  <p className="text-[var(--text-dark)] uppercase">
                    {userInfo?.role}
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-[var(--text-muted)]">
                    Name
                  </h4>
                  <p className="text-[var(--text-dark)]">
                    {userInfo?.name || "Guest"}
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-[var(--text-muted)]">
                    Code
                  </h4>
                  <p className="text-[var(--text-dark)]">
                    {userInfo?.userName}
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-[var(--text-muted)]">
                    Phone Number
                  </h4>
                  <p className="text-[var(--text-dark)]">
                    {userInfo?.phone}
                  </p>
                </div>

                              <div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    Email
  </h4>

  <p>
    {userInfo?.email || "N/A"}
  </p>
</div>
              </div>
            </div>

            {/* =================================================
                PERSONAL DETAILS
            ================================================== */}

            <div className="relative border border-[var(--border-color)] rounded-[var(--radius-md)] p-4 text-sm bg-[var(--surface-color)]">
              <button
                type="button"
                className="absolute top-3 right-3 make-text-primary hover:opacity-80 transition"
                // onClick={() =>
                //   setOpenPersonalEdit(true)
                // }
                onClick={() => {
  setPersonalEditData({
    fullName: kycData?.fullName || "",
    fatherName: kycData?.fatherName || "",
    motherName: kycData?.motherName || "",
    dob: kycData?.dob
      ? new Date(kycData.dob)
          .toISOString()
          .split("T")[0]
      : "",
    gender: kycData?.gender || "",
    address: kycData?.address || "",
    city: kycData?.city || "",
    district: kycData?.district || "",
    state: kycData?.state || "",
    pin: kycData?.pin || "",
  });

  setOpenPersonalEdit(true);
}}
              > 
                <EditSquareIcon fontSize="small" />
              </button>

              <h4 className="font-semibold text-[var(--text-dark)] text-lg mb-3">
                Personal Details
              </h4>

              <div className="space-y-4">




           

               <div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    Date of Birth
  </h4>

  <p>
    {kycLoading
      ? "Loading..."
      : kycData?.dob
      ? autoDateFormat(kycData.dob)
      : "N/A"}
  </p>
</div>

               <div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    Gender
  </h4>

  <p className="capitalize">
    {kycData?.gender || "N/A"}
  </p>
</div>

                {/* <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold text-[var(--text-muted)]">
                      PAN Number
                    </h4>
                    <p>
                      {maskedElement(
                        userInfo?.kyc?.panLast4
                      )}
                    </p>
                  </div>

                  {userInfo?.panVerified ? (
                    <span className="text-green-600 text-2xl">
                      ✔
                    </span>
                  ) : (
                    <span className="text-red-500 text-2xl">
                      ✘
                    </span>
                  )}
                </div> */}

                <div className="flex items-center justify-between">
  <div>
    <h4 className="font-semibold text-[var(--text-muted)]">
      PAN Number
    </h4>

    <p>
      {kycData?.panLast4
        ? maskedElement(kycData.panLast4)
        : "Not available"}
    </p>
  </div>

  <span
    className={
      kycData?.status === "VERIFIED"
        ? "text-green-600 text-2xl"
        : "text-orange-500 text-sm font-semibold"
    }
  >
    {kycData?.status === "VERIFIED"
      ? "✔"
      : kycData?.status || "PENDING"}
  </span>
</div>

                {/* <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold text-[var(--text-muted)]">
                      Aadhaar Number
                    </h4>
                    <p>
                      {maskedElement(
                        userInfo?.kyc?.aadhaarLast4
                      )}
                    </p>
                  </div>

                  {userInfo?.aadhaarVerified ? (
                    <span className="text-green-600 text-2xl">
                      ✔
                    </span>
                  ) : (
                    <span className="text-red-500 text-2xl">
                      ✘
                    </span>
                  )}
                </div> */}

                <div className="flex items-center justify-between">
  <div>
    <h4 className="font-semibold text-[var(--text-muted)]">
      Aadhaar Number
    </h4>

    <p>
      {kycData?.aadhaarLast4
        ? maskedElement(kycData.aadhaarLast4)
        : "Not available"}
    </p>
  </div>

  <span
    className={
      kycData?.status === "VERIFIED"
        ? "text-green-600 text-2xl"
        : "text-orange-500 text-sm font-semibold"
    }
  >
    {kycData?.status === "VERIFIED"
      ? "✔"
      : kycData?.status || "PENDING"}
  </span>
</div>

                {/* <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold text-[var(--text-muted)]">
                      Aadhaar Number
                    </h4>
                    <p>
                      {userInfo?.kyc?.aadhaar}
                    </p>
                  </div>

                  <input
                    type="checkbox"
                    checked={true}
                    readOnly
                    className="w-5 h-5"
                  />
                </div> */}

        <div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    Address
  </h4>
  <p>{kycData?.address || "N/A"}</p>
</div>

<div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    City
  </h4>
  <p>{kycData?.city || "N/A"}</p>
</div>

<div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    District
  </h4>
  <p>{kycData?.district || "N/A"}</p>
</div>

<div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    State
  </h4>
  <p>{kycData?.state || "N/A"}</p>
</div>

<div>
  <h4 className="font-semibold text-[var(--text-muted)]">
    Pincode
  </h4>
  <p>{kycData?.pin || "N/A"}</p>
</div>

                {/* <div>
                  <h4 className="font-semibold text-[var(--text-muted)]">
                    Occupation
                  </h4>
                  <p>
                    {userInfo?.kyc?.occupation}
                  </p>
                </div> */}
              </div>
            </div>

            {/* =================================================
                BRANCH
            ================================================== */}

            <div className="relative border border-[var(--border-color)] rounded-[var(--radius-md)] p-4 text-sm bg-[var(--surface-color)]">
              <button
                type="button"
                className="absolute top-3 right-3 make-text-primary hover:opacity-80 transition"
                onClick={() =>
                  setOpenBranchEdit(true)
                }
              >
                <EditSquareIcon fontSize="small" />
              </button>

              <h4 className="font-semibold text-[var(--text-dark)] text-lg mb-1">
                Branch
              </h4>

              <p>Main Branch</p>
            </div>
          </div>

          {/* ===================================================
              RIGHT PANEL
          ==================================================== */}

          <div className="flex-1 flex flex-col gap-1 mr-0 lg:mr-10">

            {/* Account Analysis */}
            <div className="ds-card py-3 px-3">
              <div className="flex flex-row justify-between items-center mb-2">
                <h3 className="font-semibold text-[var(--text-dark)] text-base">
                  Account Analysis
                </h3>
              </div>

              <div className="flex flex-row items-center gap-1">
                <div
                  ref={buttonRef}
                  className="flex gap-3"
                >
                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab("dashboard");
                      setShowBoxes(false);
                    }}
                    className={`px-3 py-1.5 rounded-md text-[13px] font-medium transition ${
                      activeTab === "dashboard"
                        ? "bg-[var(--primary-color)] text-white"
                        : "bg-primary-soft make-text-primary hover:opacity-90"
                    }`}
                  >
                    Dashboard
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab(
                        "walletLedger"
                      );
                      setShowBoxes(false);
                    }}
                    className={`px-3 py-1.5 rounded-md text-[13px] font-medium transition ${
                      activeTab ===
                      "walletLedger"
                        ? "bg-[var(--primary-color)] text-white"
                        : "bg-primary-soft make-text-primary hover:opacity-90"
                    }`}
                  >
                    Wallet Ledger
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab(
                        "addMoneyLedger"
                      );
                      setShowBoxes(false);
                    }}
                    className={`px-3 py-1.5 rounded-md text-[13px] font-medium transition ${
                      activeTab ===
                      "addMoneyLedger"
                        ? "bg-[var(--primary-color)] text-white"
                        : "bg-primary-soft make-text-primary hover:opacity-90"
                    }`}
                  >
                    Add Money Ledger
                  </button>
                </div>
              </div>
            </div>

            {/* Tab Content */}
            <div
              ref={contentRef}
              className="mt-4"
            >
              {activeTab && (
                <>
                  {activeTab === "dashboard" && (
                    <DashboardBoxes />
                  )}

                  {activeTab === "walletLedger" && (
                    <WalletLedger />
                  )}

                  {activeTab ===
                    "addMoneyLedger" && (
                    <AddMoneyLedger />
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        {/* =====================================================
            EDIT USER INFO MODAL
        ====================================================== */}

        {openEdit && (
          <div
            className="ds-overlay flex items-center justify-center p-4"
            onClick={() =>
              setOpenEdit(false)
            }
          >
            <div
              className="ds-modal w-full max-w-[400px] space-y-3"
              onClick={(e) =>
                e.stopPropagation()
              }
            >
              <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
                Edit User Info  dd
              </h2>

              <div>
                <label className="ds-label">
                  Rank
                </label>

                <input
                  type="text"
                  value={
                    userInfo?.role || ""
                  }
                  disabled
                  className="ds-input bg-[var(--bg-app)] cursor-not-allowed uppercase"
                />
              </div>

              <div>
                <label className="ds-label">
                  Name
                </label>

                <input
                  type="text"
                  value={editData.name}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      name: e.target.value,
                    })
                  }
                  className="ds-input"
                />
              </div>

              <div>
                <label className="ds-label">
                  Code
                </label>

                <input
                  type="text"
                  value={
                    userInfo?.userName || ""
                  }
                  disabled
                  className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
                />
              </div>

              <div>
                <label className="ds-label">
                  Phone Number
                </label>

                <input
                  type="text"
                  value={editData.phone}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      phone: e.target.value,
                    })
                  }
                  className="ds-input"
                />
              </div>

              <div>
                <label className="ds-label">
                  Email
                </label>

                <input
                  type="email"
                  value={editData.email}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      email: e.target.value,
                    })
                  }
                  className="ds-input"
                />
              </div>

              <div className="ds-form-actions !mt-2">
                <button
                  type="button"
                  onClick={() =>
                    setOpenEdit(false)
                  }
                  className="ds-btn ds-btn-secondary"
                  disabled={profileInfoUpdating}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={handleUpdateProfileInfo}
                  disabled={profileInfoUpdating}
                  className="ds-btn ds-btn-primary disabled:opacity-50"
                >
                  {profileInfoUpdating
                    ? "Saving..."
                    : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====================================================
            PERSONAL DETAILS MODAL
        ====================================================== */}

        {openPersonalEdit && (
          <div
            className="ds-overlay flex items-center justify-center z-[9999] p-4"
            onClick={() =>
              setOpenPersonalEdit(false)
            }
          >
            <div
              className="ds-modal w-full max-w-3xl space-y-4 max-h-[90vh] overflow-y-auto ds-scroll"
              onClick={(e) =>
                e.stopPropagation()
              }
            >
              <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
                Edit Personal Details
              </h2>

             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="ds-label">
                    Full Name
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.fullName
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        fullName:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Father's Name
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.fatherName
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        fatherName:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Mother's Name
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.motherName
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        motherName:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Date of Birth
                  </label>

                  <input
                    type="date"
                    value={
                      personalEditData.dob
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        dob:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Gender
                  </label>

                  <select
                    value={
                      personalEditData.gender
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        gender:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  >
                    <option value="">Select gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="ds-label">
                    PAN Number
                  </label>

                  <input
                    type="text"
                    value={
                      kycData?.panLast4
                        ? maskedElement(kycData.panLast4)
                        : "N/A"
                    }
                    disabled
                    title="PAN cannot be changed once submitted"
                    className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Aadhaar Number
                  </label>

                  <input
                    type="text"
                    value={
                      kycData?.aadhaarLast4
                        ? maskedElement(kycData.aadhaarLast4)
                        : "N/A"
                    }
                    disabled
                    title="Aadhaar cannot be changed once submitted"
                    className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Address
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.address
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        address:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    City
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.city
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        city:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    District
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.district
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        district:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    State
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.state
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        state:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>

                <div>
                  <label className="ds-label">
                    Pincode
                  </label>

                  <input
                    type="text"
                    value={
                      personalEditData.pin
                    }
                    onChange={(e) =>
                      setPersonalEditData({
                        ...personalEditData,
                        pin:
                          e.target.value,
                      })
                    }
                    className="ds-input"
                  />
                </div>
              </div>

              <div className="ds-form-actions !mt-2">
                <button
                  type="button"
                  onClick={() =>
                    setOpenPersonalEdit(false)
                  }
                  className="ds-btn ds-btn-secondary"
                  disabled={kycUpdating}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={handleUpdateKyc}
                  disabled={kycUpdating}
                  className="ds-btn ds-btn-primary disabled:opacity-50"
                >
                  {kycUpdating ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====================================================
            BRANCH MODAL
        ====================================================== */}

        {openBranchEdit && (
          <div
            className="ds-overlay flex items-center justify-center z-[9999] p-4"
            onClick={() =>
              setOpenBranchEdit(false)
            }
          >
            <div
              className="ds-modal w-full max-w-[400px] space-y-3"
              onClick={(e) =>
                e.stopPropagation()
              }
            >
              <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
                Edit Branch
              </h2>

              <div>
                <label className="ds-label">
                  Branch Name
                </label>

                <input
                  type="text"
                  value={
                    branchData.branchName
                  }
                  onChange={(e) =>
                    setBranchData({
                      ...branchData,
                      branchName:
                        e.target.value,
                    })
                  }
                  className="ds-input"
                />
              </div>

              <div className="ds-form-actions !mt-2">
                <button
                  type="button"
                  onClick={() =>
                    setOpenBranchEdit(false)
                  }
                  className="ds-btn ds-btn-secondary"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={() =>
                    setOpenBranchEdit(false)
                  }
                  className="ds-btn ds-btn-primary"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====================================================
            PROFILE PHOTO CONFIRMATION
        ====================================================== */}

        <ConfirmDialog
          open={confirmProfileUpdate}
          title="Update Profile Info"
          message="Are you sure you want to update your name, phone and email?"
          confirmLabel="Save"
          confirmColor="primary"
          loading={profileInfoUpdating}
          onConfirm={runProfileInfoUpdate}
          onCancel={() => {
            if (!profileInfoUpdating) {
              setConfirmProfileUpdate(false);
            }
          }}
        />

        <ConfirmDialog
  open={confirmKycUpdate}
  title="Update KYC Details"
  message="Are you sure you want to update your KYC details?"
  confirmLabel="Update"
  confirmColor="primary"
  loading={kycUpdating}
  onConfirm={runKycUpdate}
  onCancel={() => {
    if (!kycUpdating) {
      setConfirmKycUpdate(false);
    }
  }}
/>

        <ConfirmDialog
          open={confirmPhotoUpdate}
          title="Update profile photo"
          message="Are you sure you want to update your profile photo?"
          confirmLabel="Confirm"
          confirmColor="primary"
          loading={profileUpdating}
          onConfirm={runPhotoUpdate}
          onCancel={() => {
            if (!profileUpdating) {
              setConfirmPhotoUpdate(false);
            }
          }}
        />
      </Main>
    </>
  );
};

export default ProfileDashboard;